import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RangeQuestion } from '../../../classes/question-range';

@Component({
  selector: 'bepatient-input-range',
  templateUrl: './input-range.component.html',
  styleUrls: ['./input-range.component.scss'],
  standalone: false
})
export class InputRangeComponent {
  @Input() question: RangeQuestion;
  @Input() parent: UntypedFormGroup;
}
